import { useForm, zodResolver } from '@mantine/form';
import { useState } from 'react';

import { TSDData, TSDSendPresentationNotificationData, TSDSendPresentationNotificationSchema } from '@e-origin/contracts';

import { useSendPresentationNotification } from '@hooks/tsd';

interface UseSendPresentationNotificationFormInitializerProps {
  tsd: TSDData;
  tsdId: string;
  onHide(): void;
}

export const useSendPresentationNotificationFormInitializer = ({ tsd, tsdId, onHide }: UseSendPresentationNotificationFormInitializerProps) => {
  const sendPresentationNotificationMutation = useSendPresentationNotification();
  const [submitting, setSubmitting] = useState(false);

  const buildFormValues = (t: TSDData): TSDSendPresentationNotificationData => ({
    tsdId: tsdId,
    generalInfo: {
      dateAndTimeOfPresentationOfTheGoods: t?.generalInfo?.dateAndTimeOfPresentationOfTheGoods
        ? new Date(t.generalInfo.dateAndTimeOfPresentationOfTheGoods)
        : new Date(),
    },

    customsOfficeOfPresentation: {
      referenceNumber: t?.customsOfficeOfPresentation?.referenceNumber ?? '',
    },

    carrier: {
      name: t?.carrier?.name ?? '',
      identificationNumber: t?.carrier?.identificationNumber ?? '',
    },

    personPresentingTheGoods: {
      identificationNumber: t?.personPresentingTheGoods?.identificationNumber ?? '',
      name: t?.personPresentingTheGoods?.name ?? '',
      address: {
        streetAndNumber: t?.personPresentingTheGoods?.address?.streetAndNumber ?? '',
        country: t?.personPresentingTheGoods?.address?.country ?? '',
        postcode: t?.personPresentingTheGoods?.address?.postcode ?? '',
        city: t?.personPresentingTheGoods?.address?.city ?? '',
      },
      communication: {
        phoneNumber: t?.personPresentingTheGoods?.communication?.phoneNumber ?? '',
        eMailAddress: t?.personPresentingTheGoods?.communication?.eMailAddress ?? '',
      },
    },
  });

  const form = useForm<TSDSendPresentationNotificationData>({
    initialValues: buildFormValues(tsd),
    validate: zodResolver(TSDSendPresentationNotificationSchema),
    validateInputOnBlur: true,
  });

  const onSubmit = async (values: TSDSendPresentationNotificationData) => {
    try {
      setSubmitting(true);

      await sendPresentationNotificationMutation.mutateAsync(values);
      onHide();
    } catch (err) {
      // silent fail - toast handled
    } finally {
      setSubmitting(false);
      onHide();
    }
  };

  return { form, onSubmit, buildFormValues, submitting };
};
